export const toDataSourceMapper = <T>(data?: T[]): T[] | undefined => data?.map((item, index) => ({ key: index, ...item }));
